<template>
    <card :item="item" :type="type">
        <div class="cardbody color6" @click.stop="goDetails(item)">
            <div class="header">
                <div class="header-title single_hide color3">{{ item.projectName }}</div>
                <div style="font-size:16px">
                     <span v-if="item.salaryType == 1 || item.salaryType == 2" class="colorf60">{{ item.salaryTypeName }}</span>
                        <span class="colorf60" v-if="!item.salaryType || item.salaryType == 3||item.salaryType==5||item.salaryType==6">
                            {{ item.salary | formattingSalary }}元/{{item.salaryUnitName}}
                        </span>
                     <span v-if="item.salaryType==4" class="colorf60">{{ item.salary }}元/{{item.taskVolumeUnit}}</span>
                </div>
            </div>
            <div class="content">
                <div class="item_tag">
                    <span class="tagItem" style="background: #fff; padding-left: 0" v-if="item.employmentStatusName">
                        <span class="stateTag" v-if="item.employmentStatusName == '急招'" style="background-color: #e1251b">
                          {{ item.employmentStatusName }}
                        </span>
                        <span v-else class="stateTag">
                          {{item.employmentStatusName}}
                        </span>
                    </span>
                    <span class="tagItems" v-if="item.industryName">
                        {{ item.industryName }}{{item.categoryName ? "/" + item.categoryName : ""}}
                    </span>
                    <span class="tagItems">
                        用工人数:{{ item.employmentNumber ? item.employmentNumber + "人" : "--"}}
                    </span>
                </div>
                <el-row :gutter="20">
                    <el-col :span="12" class="item_text single_hide">
                        <span class="color6">所需工种:</span>
                        <span :title="item.workTypeName" class="item_data color3">{{item.workTypeName ? item.workTypeName : "--"}}</span>
                    </el-col>
                    <el-col :span="12" class="item_text single_hide">
                        <span class="color6">薪资方式:</span>
                        <span v-if="item.salaryType == 1 || item.salaryType == 2|| item.salaryType == 3">/</span>
                        <span class="item_data color3" v-if="item.salaryType == 4||item.salaryType == 5||item.salaryType == 6">{{ item.salaryTypeName}}
                        </span>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                     <el-col :span="12" class="item_texts single_hide">
                        <span class="color6">用工时间:</span>
                        <span v-if="item.startTime&&item.endTime" class="item_data color3">{{formatTime(item.startTime)}}-{{formatTime(item.endTime)}}</span>
                        <span v-else class="item_data color3">/</span>
                    </el-col>
                    <!-- <el-col :span="8" class="item_text single_hide">
                        <span class="color6">联系人:</span>
                        <span class="item_data color3">{{item.contact ? item.contact : "--"}}</span>
                    </el-col> -->
                    <el-col :span="12" class="item_texts single_hide">
                        <span class="color6">联系方式:</span>
                        <span class="item_data color3">{{item.contact ? item.contact : "--"}} {{item.contactPhone ? ShowPhone(item.contactPhone): "--"}}</span>
                    </el-col>
                </el-row>
            </div>
            <div class="address color6 single_hide">
                <img src="@/assets/team/locationIcon.png" alt="" />
                <span style="margin-left: 5px" class="color6">{{item.addressAll ? item.addressAll : ""}}</span>
                <span v-if="item.updateTime===item.createTime" class="createTime color6">{{item.createTime | formatDate}}发布</span>
                <span v-else class="createTime color6">{{item.updateTime | formatDate}}更新</span>
            </div>
        </div>
    </card>
</template>

<script>
import {checkDataStatusMessage} from "@/utils/checkDataStatus";
export default {
    name: "cardFlexibleEmployment",
    components: {
        card: () => import("@/components/card/card")
    },
    inject:['cardListCom'],
    props: {
        item: Object,
        type: Number, // 1 工队 2 工程 3 工人 4 临时用工 5 工种报价 6劳务用工
    },
    methods: {
    formatTime(time, format = 'YYYY.MM.DD') {
      return moment(time).format(format)
    },
    formatTimes(time, format = 'YYYY-MM-DD') {
      return moment(time).format(format)
    },
    //隐藏电话
    ShowPhone(phone) {
      if (phone && phone.length === 11) {
        const number = `${phone.slice(0, 3)}****${phone.slice(7, 11)}`
        return number
      }
    },
        //跳转详细
        async goDetails(item) {
          let type=await checkDataStatusMessage.call(this,this.type,item.no);
          if(type!=1){return;}
          let routeUrlC = `/FlexibleDetail?no=${item.no}`
          window.open(routeUrlC, "_blank")
          /*this.$router.push({
            path: "/FlexibleDetail",
            query: {
              no: item.no
            }
          })*/
        }
    }
}
</script>
<style lang="scss" scoped>
.cardbody {
    cursor: pointer;
    .header {
        padding: 0px 10px;
        background: #f5f7fa;
        border-bottom: 1px solid #e4e7ed;
        display: flex;
        justify-content:space-between;
        align-items: center;
        .header-title {
            font-size: 16px;
            height: 40px;
            line-height: 40px;
            max-width: 360px;
        }
    }
    .content {
        padding: 10px;
        .item_tag {
            margin-bottom: 3px;
            display: flex;
            .tagItem {
                height: 20px;
                line-height: 20px;
                background: rgba(2, 134, 223, 0.1);
                color: #0286df;
                font-size: 12px;
                margin-right: 5px;
                .stateTag {
                    padding: 0 7px;
                    height: 20px;
                    color: #fff;
                    font-size: 12px;
                    line-height: 20px;
                    text-align: center;
                    display: inline-block;
                    background-color: #409ee9;
                }
            }
                .tagItems{
                    height: 20px;
                    line-height: 20px;
                    background: rgba(2, 134, 223, 0.1);
                    color: #0286df;
                    font-size: 12px;
                    margin-right: 5px;
                    padding: 0 5px;
                }
        }
        .item_text {
            line-height: 28px;
        }
        .item_texts{
            height: 19px;
            line-height: 19px;

        }
    }
}
.address {
    position: relative;
    border-top: 1px dashed #e4e7ed;
    padding-left: 10px;
    height: 34px;
    line-height: 34px;
    img {
        vertical-align: middle;
        margin-top: -4px;
    }
    .createTime{
        position: absolute;
        right: 15px;
    }
}
.single_hide {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
div {
    box-sizing: border-box;
}
.color6 {
    color: #666666;
}
.color3 {
    color: #333333;
}
</style>
